import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';

class DBTextArea extends React.Component {
    constructor() {
        super();
        this.state = {
            value: '',
            changingTimeout: 0,
            hasChanges: false
        };
        this.handleValueChange = this.handleValueChange.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.saveValue = this.saveValue.bind(this);
    }

    componentDidMount() {
        this.setState((state) => {
            return { value: this.props.value ? this.props.value : '' };
        })
    }

    componentDidUpdate(prevProps) {
        if (this.props.noteId !== prevProps.noteId ||
            this.props.entity !== prevProps.entity ||
            this.props.entityKeyValue !== prevProps.entityKeyValue ||
            this.props.field !== prevProps.field ||
            this.props.value !== prevProps.value) {
            this.setState((state) => {
                return { value: this.props.value ? this.props.value : '', hasChanges: false };
            })
        }
    }

    handleValueChange(event) {
        if (this.state.changingTimeout) {
            clearTimeout(this.state.changingTimeout);
        }

        this.setState({
            value: event.target.value,
            hasChanges: true,
            changingTimeout: setTimeout(() => this.saveValue(), 15000)
        });
    }

    saveValue() {
        if (this.state.hasChanges) {
            this.state.value.trim() === '' ?
                this.props.clearField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field)
                :
                this.props.updateTextField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field, this.state.value);
            this.setState({ hasChanges: false });

            if (this.props.onChange) {
                this.props.onChange(this.state.value);
            }
        }
    }

    handleOnBlur() {
        this.saveValue();
        clearTimeout(this.state.changingTimeout);
    }

    render() {
        return (
            <textarea
                className={this.props.className ? this.props.className : ''}
                type="text"
                title={this.props.title ? this.props.title : ''}
                onChange={this.handleValueChange}
                onBlur={this.handleOnBlur}
                disabled={this.props.disabled}
                rows={this.props.rows ? this.props.rows : 3}
                maxLength={this.props.maxLength ? this.props.maxLength : -1}
                placeholder={this.props.placeholder}
                value={this.state.value} />
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateTextField: bindActionCreators(noteActions.updateTextField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch),

    };
}

function mapStateToProps(state, ownprops) {
    return {
        value: state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field],
        maxLength: state.entities.masterData.PTERONOTESCHEMA[ownprops.entity + '.' + ownprops.field].CHARACTER_MAXIMUM_LENGTH
    };
}

const connectedDBTextArea = connect(mapStateToProps, mapDispatchToProps)(DBTextArea);
export { connectedDBTextArea as DBTextArea };